/* eslint-disable no-console */
const getDimensionsFromAssetUrl = (url) => {
  // Returns object w/ width/height or null... should be at position 6 in array
  const a = url.split('/');
  const dims = a[6];
  if (dims !== undefined) {
    if (dims.indexOf('px') !== -1 && !Number.isNaN(parseInt(dims, 10))) {
      const b = dims.split('x');
      // Assume square, only one dimension
      if (b[1] === '') {
        b[0] = dims;
        b[1] = dims;
      }
      return {
        width: parseInt(b[0], 10),
        height: parseInt(b[1], 10),
      };
    }
  }
  return null;
};

const updateAssetUrlDimensions = (asset) => {
  const urlDims = getDimensionsFromAssetUrl(asset.src);
  if (urlDims !== null) {
    // Check for square image
    if (asset.src.indexOf(`${urlDims.width}x`) === -1) {
      return asset.src
        .replace(`${urlDims.height}px`, `${asset.width}x${asset.height}px`);
    }
    return asset.src
      .replace(`${urlDims.width}x`, `${asset.width}x`)
      .replace(`${urlDims.height}px`, `${asset.height}px`);
  }
  return asset.src;
};

const getIdFromAssetUrl = (url) => {
  const fragment = url.match(/springswindowfashions\/(.*?)\//);
  if (fragment !== null) {
    return fragment[1];
  }
  return '';
};

const getFilenameFromAssetUrl = (url) => {
  const startAt = url.lastIndexOf('/');
  const endAt = url.lastIndexOf('.');
  if (startAt !== -1 && endAt !== -1) {
    return url.substring(startAt + 1, endAt);
  }
  return '';
};

const getPosterImageFromVideoUrl = (url) => {
  const id = getIdFromAssetUrl(url);
  const filename = getFilenameFromAssetUrl(url);
  if (id !== '' && filename !== '') {
    return `https://embed.widencdn.net/poster/640/springswindowfashions/${id}/${filename}.jpg`;
  }
  return '';
};

export {
  getDimensionsFromAssetUrl,
  getFilenameFromAssetUrl,
  getIdFromAssetUrl,
  getPosterImageFromVideoUrl,
  updateAssetUrlDimensions,
};
/* eslint-enable no-console */
